import React, { useState } from "react";
import axiosInstance from "../../AxiosInstance";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

const PasswordReset = () => {
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate();

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setSuccessMessage("");

    try {
      const response = await axiosInstance.post("/v1/auth/password-reset", {
        email,
      });

      setSuccessMessage(
        "If an account with that email exists, you will receive a password reset email shortly."
      );
    } catch (error) {
      if (error.response && error.response.status === 400) {
        setErrorMessage("Invalid email address");
      } else {
        console.error("An error occurred:", error.message);
        setErrorMessage("Error occurred. Please try again later.");
      }
    }
  };

  const handleBackToLogin = () => {
    navigate("/login");
  };

  return (
    <div className="login-page-container">
      <div className="login-logo-container">
        <img src="/images/osh_navbar_logo.png" alt="Company Logo" width="350" />
      </div>
      <div className="login-contents-container">
        <h1>Reset your password</h1>
        <div className="password-reset-error-message">{errorMessage}</div>
        <div className="password-reset-success-message">{successMessage}</div>
        <form onSubmit={handlePasswordReset}>
          <div className="field-container">
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <button type="submit">Reset Password</button>
        </form>
        <div className="signup-prompt-link" onClick={handleBackToLogin}>
          Back to Login
        </div>
      </div>
    </div>
  );
};

export default PasswordReset;
